import {FC, PropsWithChildren, useMemo} from "react";
import {useCumulativeBonus, useDonateBonus} from "@hooks/selectors/user/payments.selectors";
import {injectChild} from "@constructor/functions";
import {DonateBonusProvider} from "@constructor/components/features/donate/bonuses/context";

interface CumulativeDonateBonusChildProps {
    cumulative_bonus_level: number;
}

const CumulativeDonateBonus: FC<PropsWithChildren> = ({children}) => {

    const bonusInfo = useCumulativeBonus();
    const bonus = useDonateBonus(bonusInfo?.id || '');

    const data = useMemo<CumulativeDonateBonusChildProps>(() => ({
        cumulative_bonus_level: bonusInfo?.level || 0
    }), [bonusInfo?.level]);

    if(!bonusInfo || !bonus) {
        return injectChild(data, children);
    }

    return (
        <DonateBonusProvider value={bonus}>
            {injectChild(data, children)}
        </DonateBonusProvider>
    );
}

export default CumulativeDonateBonus;